export default function() {
  return /Edg(e|iOS|A)\//i.test(navigator.userAgent);
}
